export const DETAILS_KIND = {
    visitor: 'visitor',
    account: 'account',
    mcp: 'mcp',
};
